/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {
    Box,
    Button,
    useMultiStyleConfig,
    IconButton,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Link from '@salesforce/retail-react-app/app/components/link'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BrandLogo, ChevronLeft} from '../../../components/icons'
import {useBasketTotalItems} from '../../../hooks/use-basket-total-items'

const CheckoutHeader = () => {
    const intl = useIntl()
    const navigate = useNavigation()
    const {site, locale} = useMultiSite()

    const brandName = site.id.split('-')[0]

    const totalItems = useBasketTotalItems()

    const styles = useMultiStyleConfig('Header', {variant: 'checkout'})

    const onLogoClick = () => {
        navigate(`/${locale?.alias}`)
    }

    return (
        <Box {...styles.headerBar} sx={styles.headerBarSpacing}>
            <Box {...styles.container} sx={styles.containerSpacing}>
                <Box {...styles.content}>
                    <Button
                        as={Link}
                        href="/cart"
                        display="inline-flex"
                        variant="icon-button"
                        leftIcon={<ChevronLeft />}
                        aria-label={intl.formatMessage(
                            {
                                id: 'checkout_header.link.assistive_msg.cart',
                                defaultMessage: 'Back to cart, number of items: {numItems}',
                            },
                            {numItems: totalItems},
                        )}
                    >
                        <FormattedMessage
                            defaultMessage="Back to cart"
                            id="checkout_header.link.cart"
                        />
                    </Button>
                    <Box {...styles.bodyContainer}>
                        <IconButton
                            aria-label={intl.formatMessage({
                                id: 'header.button.assistive_msg.logo',
                                defaultMessage: 'Logo',
                            })}
                            icon={
                                <BrandLogo
                                    sx={styles.logo}
                                    nutribulletBlueBrandLogo={
                                        brandName === 'nutribullet' ? true : false
                                    }
                                />
                            }
                            variant="unstyled"
                            onClick={onLogoClick}
                            data-testid="logo-button"
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default CheckoutHeader
